"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_style_1 = __importDefault(require("./avatar.style"));
const avatar_bg_svg_1 = __importDefault(require("./avatar.bg.svg"));
class Avatar extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.renderRatioImage = () => (jsx_runtime_1.jsx("img", { className: this.props.classes.ratioImage, src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", alt: "" }, void 0));
        this.render = () => {
            const { classes, size, src } = this.props;
            const rootProps = {
                className: classes.root,
                'data-has-border': true,
                style: {
                    backgroundImage: `url(${src || avatar_bg_svg_1.default})`,
                    width: size,
                    height: size
                }
            };
            return jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: this.renderRatioImage() }), void 0);
        };
    }
}
exports.Avatar = Avatar;
Avatar.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    src: prop_types_1.default.string,
    size: prop_types_1.default.number
};
Avatar.defaultProps = {
    src: null,
    size: null
};
exports.default = react_jss_1.default(avatar_style_1.default)(Avatar);
//# sourceMappingURL=avatar.js.map